import { AdditionalDetailsData } from '@adyen/adyen-web';
import { browserApi } from 'lib/httpClient';
import { browserLogger } from 'utils/logger/browserLogger';
import { getErrorDetails } from 'utils/getErrorDetails';

export async function makePaymentDetails(
  details: AdditionalDetailsData,
  orderNum: string,
  owner: 'bileto' | 'platform'
) {
  const logger = browserLogger();

  try {
    const result = details?.data?.details?.threeDSResult;
    if (!result) {
      throw new Error('ThreeDS result is required');
    }
    const { data } = await browserApi.post(`/three-ds`, {
      orderNum,
      result,
      owner
    });

    if (!data.success) {
      throw new Error(data.error || 'ThreeDS confirmation failed');
    }
  } catch (err) {
    const errorDetails = getErrorDetails(err);

    logger.error(
      {
        message: `[DiscoveryNext][3DS] ${window.location.pathname} Payment Details Failed`,
        data: { orderNum },
        extra: {
          orderNum,
          owner,
          env: process?.env?.APP_ENVIRONMENT,
          application: 'purchase',
          endpoint: '/api/v1/checkout/threeds-confirmation-auth',
          error: {
            message: errorDetails.message,
            stack: errorDetails.stack
          }
        }
      },
      'makePaymentDetails'
    );
  }
}
